import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import CreateAccount from '../pages/create-account/CreateAccount';
import VerifyEmail from '../pages/create-account/VerifyEmail';
import Login from '../pages/login/Login';
import LoginVerifyEmail from '../pages/login/pages/VerifyEmail';
import LoginVerifyIp from '../pages/login/pages/VerifyIP';
import LoginHelp from '../pages/login-help/LoginHelp';
import Account from '../pages/account/Account';
import LinkAccount from '../pages/account/Link';
import UnlinkAccount from '../pages/account/Unlink';
import ResetPassword from '../pages/login-help/pages/ResetPassword';
import Blocked from '../pages/misc/Blocked';
import ParentalConfirmation from '../pages/misc/ParentalConsentConfirmation';
import StepTwo from '../pages/create-account/StepTwo';
import ParentalConsent from '../pages/create-account/ParentalConsent';
import Cookies from 'js-cookie';
import ChangeUsername from '../pages/login/pages/ChangeUsername';
import ParentalConsentThankYou from '../pages/misc/ParentalConsentThankYou';

const Router = () => {
  const token = Cookies.get('_barbToken');

  return (
    <Routes>
      <Route path="/" element={<Navigate to={token ? '/account' : '/login'} />} />

      {/* Create Account */}
      <Route path="/create-account" element={<CreateAccount />} />
      <Route path="/create-account/step-two" element={<StepTwo />} />
      <Route path="/create-account/parental-consent" element={<ParentalConsent />} />
      <Route path="/create-account/parental-thank-you" element={<ParentalConsentThankYou />} />
      <Route path="/verify-email" element={<VerifyEmail />} />

      {/* Account */}
      <Route path="/account" element={<Account />} />
      <Route path="/link/:platform" element={<LinkAccount />} />
      <Route path="/unlink/:platform" element={<UnlinkAccount />} />

      {/* Login */}
      <Route path="/login" element={<Login />} />
      <Route path="/login/verify-email" element={<LoginVerifyEmail />} />
      <Route path="/login/verify-ip" element={<LoginVerifyIp />} />
      <Route path="/login/username-change" element={<ChangeUsername />} />

      {/* Recovery */}
      <Route path="/login-help" element={<LoginHelp />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Error */}
      <Route path="/blocked" element={<Blocked />} />

      {/* Short referral URL */}
      <Route path="/r/:code" element={<CreateAccountWithReferral />} />

      {/* Misc */}
      <Route path="/parental-confirmation" element={<ParentalConfirmation />} />
    </Routes>
  );
};

const CreateAccountWithReferral = () => {
  const { code } = useParams();

  useEffect(() => {
    window.location.replace(`/create-account?referral_id=${code}`);
  }, [code]);

  return null;
};

export default Router;
